/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum InputCriteriaCurrencyCodeEnum {
    EQUAL_TO = 'EQUAL_TO',
    BIGGER_THAN = 'BIGGER_THAN',
    EQUAL_OR_BIGGER_THAN = 'EQUAL_OR_BIGGER_THAN',
    SMALLER_THAN = 'SMALLER_THAN',
    EQUAL_OR_SMALLER_THAN = 'EQUAL_OR_SMALLER_THAN',
    BETWEEN = 'BETWEEN',
}
